import { render, staticRenderFns } from "./sim-infos.vue?vue&type=template&id=7afed475&scoped=true&"
import script from "./sim-infos.vue?vue&type=script&lang=js&"
export * from "./sim-infos.vue?vue&type=script&lang=js&"
import style0 from "./sim-infos.vue?vue&type=style&index=0&id=7afed475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afed475",
  null
  
)

export default component.exports